// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   Cookie Consent Banner — Ofertiz LGPD
   ============================================ */

.cookie-consent-overlay {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  padding: 12px 16px;
  animation: slideUpCookie 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

@keyframes slideUpCookie {
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.cookie-consent-banner {
  max-width: 960px;
  margin: 0 auto;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 -4px 32px rgba(0, 0, 0, 0.12), 0 8px 32px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(52, 131, 250, 0.15);
  padding: 20px 24px;
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.cookie-consent-icon {
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, rgba(52, 131, 250, 0.1), rgba(52, 131, 250, 0.2));
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  color: var(--primary-color, #3483fa);
}

.cookie-consent-content {
  flex: 1 1;
  min-width: 220px;
}

.cookie-consent-title {
  font-size: 15px;
  font-weight: 700;
  color: var(--text-primary, #1a1a2e);
  margin: 0 0 6px 0;
}

.cookie-consent-text {
  font-size: 13px;
  color: var(--text-secondary, #666);
  line-height: 1.55;
  margin: 0;
}

.cookie-consent-link {
  color: var(--primary-color, #3483fa);
  font-weight: 600;
  text-decoration: none;
}

.cookie-consent-link:hover {
  text-decoration: underline;
}

.cookie-consent-actions {
  display: flex;
  gap: 10px;
  flex-shrink: 0;
  flex-wrap: wrap;
}

.cookie-btn {
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.cookie-btn-essential {
  background: #f0f0f0;
  color: #555;
  border: 1px solid #ddd;
}

.cookie-btn-essential:hover {
  background: #e0e0e0;
  color: #333;
}

.cookie-btn-accept {
  background: var(--primary-color, #3483fa);
  color: #ffffff;
  display: flex;
  align-items: center;
  gap: 6px;
}

.cookie-btn-accept:hover {
  background: #2567d4;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(52, 131, 250, 0.35);
}

/* Mobile */
@media (max-width: 600px) {
  .cookie-consent-banner {
    flex-direction: column;
    align-items: flex-start;
    padding: 16px;
  }

  .cookie-consent-actions {
    width: 100%;
  }

  .cookie-btn {
    flex: 1 1;
    justify-content: center;
    text-align: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/CookieConsent.css"],"names":[],"mappings":"AAAA;;iDAEiD;;AAEjD;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,kBAAkB;EAClB,kEAAkE;AACpE;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,2EAA2E;EAC3E,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,qFAAqF;EACrF,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yCAAyC;EACzC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA,WAAW;AACX;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAO;IACP,uBAAuB;IACvB,kBAAkB;EACpB;AACF","sourcesContent":["/* ============================================\n   Cookie Consent Banner — Ofertiz LGPD\n   ============================================ */\n\n.cookie-consent-overlay {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 9999;\n  padding: 12px 16px;\n  animation: slideUpCookie 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n}\n\n@keyframes slideUpCookie {\n  from {\n    transform: translateY(100%);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n.cookie-consent-banner {\n  max-width: 960px;\n  margin: 0 auto;\n  background: #ffffff;\n  border-radius: 16px;\n  box-shadow: 0 -4px 32px rgba(0, 0, 0, 0.12), 0 8px 32px rgba(0, 0, 0, 0.08);\n  border: 1px solid rgba(52, 131, 250, 0.15);\n  padding: 20px 24px;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.cookie-consent-icon {\n  flex-shrink: 0;\n  width: 48px;\n  height: 48px;\n  background: linear-gradient(135deg, rgba(52, 131, 250, 0.1), rgba(52, 131, 250, 0.2));\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 22px;\n  color: var(--primary-color, #3483fa);\n}\n\n.cookie-consent-content {\n  flex: 1;\n  min-width: 220px;\n}\n\n.cookie-consent-title {\n  font-size: 15px;\n  font-weight: 700;\n  color: var(--text-primary, #1a1a2e);\n  margin: 0 0 6px 0;\n}\n\n.cookie-consent-text {\n  font-size: 13px;\n  color: var(--text-secondary, #666);\n  line-height: 1.55;\n  margin: 0;\n}\n\n.cookie-consent-link {\n  color: var(--primary-color, #3483fa);\n  font-weight: 600;\n  text-decoration: none;\n}\n\n.cookie-consent-link:hover {\n  text-decoration: underline;\n}\n\n.cookie-consent-actions {\n  display: flex;\n  gap: 10px;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n}\n\n.cookie-btn {\n  padding: 10px 20px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  border: none;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n\n.cookie-btn-essential {\n  background: #f0f0f0;\n  color: #555;\n  border: 1px solid #ddd;\n}\n\n.cookie-btn-essential:hover {\n  background: #e0e0e0;\n  color: #333;\n}\n\n.cookie-btn-accept {\n  background: var(--primary-color, #3483fa);\n  color: #ffffff;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.cookie-btn-accept:hover {\n  background: #2567d4;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(52, 131, 250, 0.35);\n}\n\n/* Mobile */\n@media (max-width: 600px) {\n  .cookie-consent-banner {\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 16px;\n  }\n\n  .cookie-consent-actions {\n    width: 100%;\n  }\n\n  .cookie-btn {\n    flex: 1;\n    justify-content: center;\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
